export default __webpack_public_path__ + "static/media/transparent-black-ph-spinner.59505dc6.gif";